module.exports = __webpack_public_path__ + "static/media/gaizao-njqh.fc8ec6d4.jpg";